export default __webpack_public_path__ + "static/media/pdf-file.d9f48a51.svg";